import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  DeleteRatingandreviewUploadFileApi,
  GetRatingandreviwsApi,
  GetTenantRatingandreviwsApi,
  PostRatingAndReviewApi,
  RatingandreviewUploadFileApi,
  UpdateRatingAndReviewApi,
  GetReviewVideoApi,
} from "../../api/product-processing-api/ProductReviewApi";

// Get all reviews
export const GetRatingandreviws = createAsyncThunk(
  "review/GetRatingandreviws",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetRatingandreviwsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || "Failed to get reviews",
      });
    }
  }
);

// Get tenant reviews
export const GetTenantRatingandreviws = createAsyncThunk(
  "review/GetTenantRatingandreviws",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetTenantRatingandreviwsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage:
          err?.response?.data?.message || "Failed to get tenant reviews",
      });
    }
  }
);

// Post review
export const PostRatingAndReview = createAsyncThunk(
  "review/PostRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PostRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage:
          err?.response?.data?.message || "Failed to post rating and review",
      });
    }
  }
);

// Update review
export const UpdateRatingAndReview = createAsyncThunk(
  "review/UpdateRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await UpdateRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage:
          err?.response?.data?.message || "Failed to update rating and review",
      });
    }
  }
);

// Upload image
export const RatingandreviewUploadFileImag = createAsyncThunk(
  "review/RatingandreviewUploadFileImag",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || "Failed to upload image",
      });
    }
  }
);

// Delete image
export const RatingandreviewUploadFileImgDelete = createAsyncThunk(
  "review/RatingandreviewUploadFileImgDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DeleteRatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || "Failed to delete image",
      });
    }
  }
);

// Upload video
export const RatingandreviewUploadFileVideo = createAsyncThunk(
  "review/RatingandreviewUploadFileVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || "Failed to upload video",
      });
    }
  }
);

// Delete video
export const RatingandreviewUploadFileVideoDelete = createAsyncThunk(
  "review/RatingandreviewUploadFileVideoDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DeleteRatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message || "Failed to delete video",
      });
    }
  }
);

// Get review video
export const GetReviewVideo = createAsyncThunk(
  "review/GetReviewVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetReviewVideoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage:
          err?.response?.data?.message || "Failed to get review video",
      });
    }
  }
);

const initialState = {
  reviewImg: {},
  reviewVideo: {},
  reviews: [],
  reviewsTenant: {},
  loading: false,
  uploading: false,
  reviewVideoFloat: [],
  error: null,
};

const ProductReviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get reviews
      .addCase(GetRatingandreviws.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetRatingandreviws.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload?.response || [];
      })
      .addCase(GetRatingandreviws.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Get tenant reviews
      .addCase(GetTenantRatingandreviws.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetTenantRatingandreviws.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewsTenant = action.payload?.response || {};
      })
      .addCase(GetTenantRatingandreviws.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Post review
      .addCase(PostRatingAndReview.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(PostRatingAndReview.fulfilled, (state) => {
        state.uploading = false;
      })
      .addCase(PostRatingAndReview.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Update review
      .addCase(UpdateRatingAndReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateRatingAndReview.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(UpdateRatingAndReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Upload image
      .addCase(RatingandreviewUploadFileImag.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(RatingandreviewUploadFileImag.fulfilled, (state, action) => {
        state.uploading = false;
        state.reviewImg = action.payload?.response || {};
      })
      .addCase(RatingandreviewUploadFileImag.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Delete image
      .addCase(RatingandreviewUploadFileImgDelete.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(RatingandreviewUploadFileImgDelete.fulfilled, (state) => {
        state.uploading = false;
        state.reviewImg = {};
      })
      .addCase(RatingandreviewUploadFileImgDelete.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Upload video
      .addCase(RatingandreviewUploadFileVideo.pending, (state) => {
        state.uploading = true;
        state.error = null;
      })
      .addCase(RatingandreviewUploadFileVideo.fulfilled, (state, action) => {
        state.uploading = false;
        state.reviewVideo = action.payload?.response || {};
      })
      .addCase(RatingandreviewUploadFileVideo.rejected, (state, action) => {
        state.uploading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Get review video
      .addCase(GetReviewVideo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetReviewVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewVideoFloat = action.payload?.response || [];
      })
      .addCase(GetReviewVideo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.errorMessage || "Something went wrong";
      })

      // Delete video
      .addCase(RatingandreviewUploadFileVideoDelete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(RatingandreviewUploadFileVideoDelete.fulfilled, (state) => {
        state.loading = false;
        state.reviewVideo = {};
      })
      .addCase(
        RatingandreviewUploadFileVideoDelete.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload?.errorMessage || "Something went wrong";
        }
      );
  },
});

export default ProductReviewSlice.reducer;